import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/PatientNameDisplay.css";

const PatientNameDisplay = ({ user }) => {
  const { t } = useTranslation();
  const [fullName, setFullName] = useState("");

  useEffect(() => {
    if (user?.first_name || user?.last_name) {
      const name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      setFullName(name);
    }
  }, [user]);

  return (
    <div className="patient-name-container">
      <label>{t("pat_new_sched.patient_name_label")}</label>
      <div className="patient-name-box-1">
        {fullName || t("pat_new_sched.name_not_available")}
      </div>
    </div>
  );
};

export default PatientNameDisplay;
